<br />
<fieldset class="border rounded-3 p-3">
  <legend class="w-auto">Debugging Data</legend>
  <mat-accordion>
    <mat-expansion-panel>
      <mat-expansion-panel-header>
        <mat-panel-title> MAWP Data </mat-panel-title>
        <mat-panel-description>
          Click here to expand the MAWP Data panel
        </mat-panel-description>
      </mat-expansion-panel-header>
      <p [innerHTML]="MAWPValues"></p>
    </mat-expansion-panel>
    <mat-expansion-panel>
      <mat-expansion-panel-header>
        <mat-panel-title> GML Data </mat-panel-title>
        <mat-panel-description>
          Click here to expand the GML Data panel
        </mat-panel-description>
      </mat-expansion-panel-header>
      <p [innerHTML]="GMLValues"></p>
    </mat-expansion-panel>
    <mat-expansion-panel>
      <mat-expansion-panel-header>
        <mat-panel-title> CalcTemplate Data </mat-panel-title>
        <mat-panel-description>
          Click here to expand the CalcTemplate Data panel
        </mat-panel-description>
      </mat-expansion-panel-header>
      <p [innerHTML]="CalcTemplateValues"></p>
    </mat-expansion-panel>
    <mat-expansion-panel>
      <mat-expansion-panel-header>
        <mat-panel-title> LTA Data </mat-panel-title>
        <mat-panel-description>
          Click here to expand the LTA Data panel
        </mat-panel-description>
      </mat-expansion-panel-header>
      <p [innerHTML]="LTAValues"></p>
    </mat-expansion-panel>
    <mat-expansion-panel>
      <mat-expansion-panel-header>
        <mat-panel-title> Blister/HIC Data </mat-panel-title>
        <mat-panel-description>
          Click here to expand the Blister/HIC Data panel
        </mat-panel-description>
      </mat-expansion-panel-header>
      <p [innerHTML]="BlisterHICValues"></p>
    </mat-expansion-panel>
    <mat-expansion-panel>
      <mat-expansion-panel-header>
        <mat-panel-title> Crack-Like Data </mat-panel-title>
        <mat-panel-description>
          Click here to expand the Crack-Like Data panel
        </mat-panel-description>
      </mat-expansion-panel-header>
      <p [innerHTML]="CrackValues"></p>
    </mat-expansion-panel>
    <mat-expansion-panel>
      <mat-expansion-panel-header>
        <mat-panel-title> Gouge Data </mat-panel-title>
        <mat-panel-description>
          Click here to expand the Gouge Data panel
        </mat-panel-description>
      </mat-expansion-panel-header>
      <p [innerHTML]="GougeValues"></p>
    </mat-expansion-panel>
  </mat-accordion>
  <br />
  <button class="btn btn-primary no-arrow float-right" (click)="refreshData()">
    Refresh Data
    <span class="icon-play-triangle"></span>
  </button>
</fieldset>
